import React from 'react';
import { Route } from 'react-router-dom';

import ProgBasicoFicha from '../../Progromacao/basico/ProgBasicoFicha';
import ProgBasicoIndex from '../../Progromacao/basico/ProgBasicoIndex';
import EntregasIndex from '../../Progromacao/entregas/EntregasIndex';
import ProgEspecializadoEntregas from '../../Progromacao/especializado/ProgEspecializadoEntregas';
import ProgEspecializadoFicha from '../../Progromacao/especializado/ProgEspecializadoFicha';
import ProgEspecializadoIndex from '../../Progromacao/especializado/ProgEspecializadoIndex';
import ProgEspecializadoNotificacoes from '../../Progromacao/especializado/ProgEspecializadoNotificacoes';
import ProgEstrategicoFicha from '../../Progromacao/estrategico/ProgEstrategicoFicha';
import ProgEstrategicoIndex from '../../Progromacao/estrategico/ProgEstrategicoIndex';

const ProgramacaoRoutes = () => {
  return (
    <>
      {/* Básico */}
      <Route path="programacao/basico" element={<ProgBasicoIndex />} />
      <Route
        path="programacao/basico/ficha/dadosgerais"
        element={<ProgBasicoFicha />}
      />
      {/* <Route
        path="produtosdaf/produtos/ficha/:id/dadosgerais"
        element={<ProdutosDadosGerais />}
      /> */}

      {/* Especializado */}
      <Route
        path="programacao/especializado"
        element={<ProgEspecializadoIndex />}
      />
      <Route
        path="programacao/especializado/ficha/dadosgerais"
        element={<ProgEspecializadoFicha />}
      />
      <Route
        path="programacao/especializado/ficha/notificacoes"
        element={<ProgEspecializadoNotificacoes />}
      />
      <Route
        path="programacao/especializado/ficha/entregas"
        element={<ProgEspecializadoEntregas />}
      />

      {/* Estratégico */}
      <Route
        path="programacao/estrategico"
        element={<ProgEstrategicoIndex />}
      />
      <Route
        path="programacao/estrategico/ficha/dadosgerais"
        element={<ProgEstrategicoFicha />}
      />

      {/* Entregas */}
      <Route path="programacao/entregas" element={<EntregasIndex />} />
      <Route
        path="programacao/entregas/ficha/dadosgerais"
        element={<EntregasIndex />}
      />
    </>
  );
};

export default ProgramacaoRoutes;
